module.exports = "<div ng-show=\"vm.daysOfWeek\" class=\"weeksdaysCampaign\" translate=\"reoccurs_every_weekdays\"  translate-value-weekdays=\"{{vm.daysOfWeek}}\"></div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/app.retailer.common/components/days-of-week/days-of-week.html
// module id = 29
// module chunks = 0 1 3 4